import './styles.scss'

import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'

import DeliveryDate from '@/components/B2bDeliveryDate'
import { InfoIcon } from '@/components/Icons'
import { useAppDispatch, useAppSelector } from '@/store/hook'
import { selectHideEstimatedDeliveryTime } from '@/store/selectors/configSelector'
import { changeCartProductReference } from '@/store/slices/cartSlice'
import { formatQuantity } from '@/libs/utils/handleNumber'

interface CheckoutNameBlockProps {
  record?: {
    productReference?: string
    materialNumber?: string
    quantity?: string | number
    name?: string
    isDangerous?: boolean
    price?: number
  }
}

const CheckoutNameBlock = ({ record }: CheckoutNameBlockProps) => {
  const isHideEstimatedDeliveryTime = useAppSelector(
    selectHideEstimatedDeliveryTime,
  )
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [productPreference, setProductReference] = useState(
    record?.productReference,
  )

  const timerRef = useRef()
  const handleChangeProductReference = (value) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    if (record?.price === 0) {
      return
    }

    timerRef.current = setTimeout(() => {
      dispatch(
        changeCartProductReference({
          materialNumber: record?.materialNumber,
          productReference: value,
          quantity: record?.quantity,
        }),
      )
    }, 300)
  }

  return (
    <div className="checkout-name__wrapper">
      <div className="checkout-name__top">
        <span className="checkout-name__top__name">{record?.name}</span>
        <span className="checkout-name__top__quantity">
          {formatQuantity(record?.quantity)}
        </span>
      </div>
      <div className="checkout-name__middle">
        {!isHideEstimatedDeliveryTime && <DeliveryDate deliveryData={record?.deliveryData} />}
      </div>
      {record?.isDangerous && (
        <div className="checkout-name__middle__dangerous-goods">
          <InfoIcon className="checkout-name__middle__dangerous-goods__icon" />
          <span>
            {t('checkout.step3.middleSection.table.dangerousGoodsHint')}
          </span>
        </div>
      )}
      <div className="checkout-name__bottom">
        <span
          className="checkout-name__bottom__title"
          style={{ display: 'block', textTransform: 'uppercase' }}
        >
          {t('checkout.step3.middleSection.table.productPreference')}
        </span>
        <Input
          className="custom-input checkout-name__bottom__reference-product"
          disabled={record?.price === 0}
          name="productReference"
          type="text"
          value={productPreference}
          placeholder={t(
            'checkout.step3.middleSection.table.productPreference',
          )}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            if (productPreference !== e.target.value) {
              setProductReference(e.target.value)
              handleChangeProductReference(e.target.value)
            }
          }}
        />
      </div>
    </div>
  )
}

export default CheckoutNameBlock
